import type { QTableColumn } from 'quasar';
import { formatDate } from 'src/utils/formatDate';
export interface ResourceTypeModelInput {
  id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}
export interface ResourceTypeModelCreateAttributes {
  name: string;
  description: string;
}
export interface ResourceTypeModelUpdateAttributes {
  name: string;
  description: string;
}
export interface ResourceTypeModelAttributes {
  id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}
export class ResourceTypeModel {
  id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;

  constructor(input?: ResourceTypeModelInput) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.description = input ? input.description : '';
    this.created_at = input ? formatDate(input.created_at) : '';
    this.updated_at = input ? formatDate(input.updated_at) : '';
  }

  getId(): string {
    return this.id;
  }
  getAttributes(): ResourceTypeModelAttributes {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      created_at: this.created_at,
      updated_at: this.updated_at,
    };
  }
  getCreateAttributes(): ResourceTypeModelCreateAttributes {
    return {
      name: this.name,
      description: this.description,
    };
  }
  getUpdateAttributes(): ResourceTypeModelUpdateAttributes {
    return {
      name: this.name,
      description: this.description,
    };
  }
}
export type ResourceTypeCollection = ResourceTypeModel[];
export const ResourceTypeTableColumns: QTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    align: 'left',
    field: 'id',
    sortable: true,
  },
  {
    name: 'name',
    label: 'リソースタイプ名',
    align: 'left',
    field: 'name',
    sortable: true,
  },
  {
    name: 'description',
    label: '説明',
    align: 'left',
    field: 'description',
    sortable: false,
  },
  {
    name: 'created_at',
    label: '作成日',
    align: 'left',
    field: 'created_at',
    sortable: true,
  },
];
